import type { StatusPedido } from '@pgcustom/shared-types';

/** Rótulos compartilhados entre a listagem e o detalhe — mesmo padrão de `clientes/classificacao.ts`. */
export const STATUS_PEDIDO: Array<{ valor: StatusPedido; rotulo: string }> = [
  { valor: 'pendente', rotulo: 'Pendente' },
  { valor: 'pago', rotulo: 'Pago' },
  { valor: 'cancelado', rotulo: 'Cancelado' },
];

export function rotuloStatusPedido(valor: StatusPedido): string {
  return STATUS_PEDIDO.find((opcao) => opcao.valor === valor)?.rotulo ?? valor;
}
